import { isOrderPaid } from "@features/orders/order-paid-status";
import { type OrderStatusType } from "@relay/paymentProviderLink_OrderFragment.graphql";

type OrderBuyerFacts = {
	readonly purchaser?: unknown;
	readonly startedAsGuest?: boolean | null;
	readonly status?: OrderStatusType | null;
};

export const isUnclaimedGuestOrder = (order: OrderBuyerFacts) =>
	!order.purchaser && (!!order.startedAsGuest || (!!order.status && isOrderPaid(order.status)));
